















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Consent } from '@/interface/api'
import sanitize from 'sanitize-html'

@Component({
  name: 'ConsentTemplate'
})
export default class ConsentTemplate extends Vue {
  @Prop({ default: () => [] }) private consents!: Consent[]
  @Prop({ default: false }) private loading!: boolean

  private sanitizedContents: { title: string; id: string; content: string }[] =
    []
  private expandedPanels: number[] = []
  private consentAgreements: boolean[] = []
  private hasBeenOpened: boolean[] = []

  private get allConsentsAgreed(): boolean {
    return this.consentAgreements.every(agreed => agreed)
  }

  private onAccordionChange(expandedIndexes: number[]) {
    expandedIndexes.forEach(index => {
      if (!this.hasBeenOpened[index]) {
        this.$set(this.hasBeenOpened, index, true)
      }
    })
  }

  private sanitizeOptions = {
    allowedTags: false as const,
    allowedAttributes: false as const,
    allowedSchemes: ['http', 'https', 'data']
  }

  @Watch('consents')
  private onConsentsChange() {
    if (this.consents.length === 0) return
    this.sanitizedContents = this.consents.map(consent => {
      return {
        title: consent.title,
        id: consent.id,
        content: sanitize(consent.content, this.sanitizeOptions)
      }
    })

    this.consentAgreements = new Array(this.sanitizedContents.length).fill(false)
    this.hasBeenOpened = new Array(this.sanitizedContents.length).fill(false)
  }

  private mounted() {
    this.sanitizedContents = this.consents.map(consent => {
      return {
        title: consent.title,
        id: consent.id,
        content: sanitize(consent.content, this.sanitizeOptions)
      }
    })
    
    this.consentAgreements = new Array(this.sanitizedContents.length).fill(false)
    this.hasBeenOpened = new Array(this.sanitizedContents.length).fill(false)
  }
}
